function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled from "@emotion/styled/base";

function cov_1a26aq8bua() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/GenericError/GenericError.tsx";
  var hash = "34426f60469a089e69aa7878d88cd9aaa6d89939";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/GenericError/GenericError.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 21,
          column: 2
        }
      },
      "1": {
        start: {
          line: 24,
          column: 60
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "2": {
        start: {
          line: 29,
          column: 56
        },
        end: {
          line: 29,
          column: 66
        }
      },
      "3": {
        start: {
          line: 30,
          column: 23
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 49,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 28
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 36,
            column: 13
          },
          end: {
            line: 36,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 42
          }
        }, {
          start: {
            line: 36,
            column: 45
          },
          end: {
            line: 36,
            column: 73
          }
        }],
        line: 36
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 11
          },
          end: {
            line: 46,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 24
          }
        }, {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 45,
            column: 16
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "34426f60469a089e69aa7878d88cd9aaa6d89939"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1a26aq8bua = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1a26aq8bua();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React from 'react';
import { media } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';
import { fontSizesNamed } from '@opendoor/bricks/theme/eero';
var HeaderContent = (cov_1a26aq8bua().s[0]++, _styled("h1", process.env.NODE_ENV === "production" ? {
  target: "exdhafc0"
} : {
  target: "exdhafc0",
  label: "HeaderContent"
})(_defineProperty({
  wordBreak: 'break-word',
  fontSize: "".concat(fontSizesNamed.s3)
}, media.largerThan.MD, {
  fontSize: "".concat(fontSizesNamed.s5)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var GenericError = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GenericError, _React$PureComponent);

  var _super = _createSuper(GenericError);

  function GenericError() {
    _classCallCheck(this, GenericError);

    return _super.apply(this, arguments);
  }

  _createClass(GenericError, [{
    key: "render",
    value: function render() {
      cov_1a26aq8bua().f[0]++;

      var _ref = (cov_1a26aq8bua().s[2]++, this.props),
          errorContent = _ref.errorContent,
          showBorder = _ref.showBorder,
          headerContent = _ref.headerContent;

      var errorEmail = (cov_1a26aq8bua().s[3]++, 'contact@opendoor.com');
      cov_1a26aq8bua().s[4]++;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('box', {
          'no-shadow': !showBorder
        })
      }, /*#__PURE__*/React.createElement("section", {
        className: "text-center "
      }, /*#__PURE__*/React.createElement(HeaderContent, null, headerContent ? (cov_1a26aq8bua().b[0][0]++, headerContent) : (cov_1a26aq8bua().b[0][1]++, 'Oops, something went wrong')), errorContent ? (cov_1a26aq8bua().b[1][0]++, errorContent) : (cov_1a26aq8bua().b[1][1]++, /*#__PURE__*/React.createElement("p", null, "It looks like we ran into an issue. Please try again.", /*#__PURE__*/React.createElement("br", null), "Email us at ", /*#__PURE__*/React.createElement("a", {
        href: "mailto:".concat(errorEmail)
      }, errorEmail), " if the problem persists."))));
    }
  }]);

  return GenericError;
}((React.PureComponent));

_defineProperty(GenericError, "defaultProps", (cov_1a26aq8bua().s[1]++, {
  showBorder: true
}));

export { GenericError as default };